import React from 'react';
import AlertNotification from './AlertNotification';
import { AccountEditNotification } from './AccountEditNotification';
import { useAccountEditNotifications } from '../../../../context/AccountEditNotifications';
import { useAlerts } from './AlertContext';

export const AlertManager: React.FC = () => {
  const { alerts, markAlertAsNew, acknowledgeAlert } = useAlerts();
  const edits = useAccountEditNotifications();
  const notice = edits.notice;
  const notSeenAlerts = alerts.filter(alert => alert.data.visibility === 'NOT_SEEN');

  const handleAcknowledgeAlert = async (alertId: string) => {
    await acknowledgeAlert(alertId);
  };

  const handleDismissAlert = async (alertId: string, visibility: 'ACKNOWLEDGED' | 'DISMISSED') => {
    if (visibility === 'ACKNOWLEDGED') {
      await handleAcknowledgeAlert(alertId);
    } else {
      await markAlertAsNew(alertId);
    }
  };

  if (notSeenAlerts.length === 0 && !notice) return null;

  return (
    <div className="alert-manager">
      {notice && <AccountEditNotification
        key={`${notice.id}:${notice.notification_revision ?? notice.status}`}
        job={notice}
        onClose={edits.closeNotice}
        onReview={() => { edits.open(notice); edits.closeNotice(); }}
      />}
      {notSeenAlerts.map((alert) => (
        <AlertNotification
          key={alert.id}
          alert={alert.data}
          alertId={alert.id}
          onDismiss={handleDismissAlert}
          onClose={() => {}}
        />
      ))}
    </div>
  );
};

export default AlertManager;